import(/* webpackMode: "eager" */ "/app/src/app/[locale]/order-lookup/page.tsx");
